import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BuyerStatusState  {
    status:'SUCCESS' | 'PARTIAL SUCCESS'| null;
    failedBuyers: string[];
}

const initialState: BuyerStatusState = {
    status: null,
    failedBuyers:[],
};

const buyerStatusSlice = createSlice({
    name: "buyerStatus",
    initialState,
    reducers: {
        setBuyerStatus(
            state,
            action: PayloadAction<{
                status: "SUCCESS" | "PARTIAL SUCCESS" ; failedBuyers?: string[]
            }>,
        ) {

            state.status = action.payload.status;
            state.failedBuyers= action.payload.failedBuyers || [];
        },
        resetBuyerStatus(state) {
            state.status = null;
            state.failedBuyers= [];
        },
    },
});

export const { setBuyerStatus, resetBuyerStatus } = buyerStatusSlice.actions;
export default buyerStatusSlice.reducer;
